/* wo-map-mobile.js — ultra safe + ensureSingleList (最新の一覧だけ表示) */
(() => {
  const MQ = window.matchMedia('(max-width:768px)');

  // Omniumが複製する一覧から「最新（最後）」だけを取得
  function getLatestListWrap(section){
    const wraps = Array.from(section.querySelectorAll('.develic-items-wrapper'));
    return wraps.length ? wraps[wraps.length - 1] : null;
  }

  // 古い一覧は非表示、最後の一覧のみ表示
  function ensureSingleList(section){
    const wraps = Array.from(section.querySelectorAll('.develic-items-wrapper'));
    const lastIndex = wraps.length - 1;
    wraps.forEach((w, i) => {
      if (i === lastIndex){
        w.style.display = '';         // 表示
        w.removeAttribute('aria-hidden');
      } else {
        w.style.display = 'none';     // 非表示
        w.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function apply(section){
    try{
      if(!section) return;

      const panel   = section.querySelector('.develic-left-panel');
      const body    = section.querySelector('.develic-body');

      // 検索は form を最優先で拾う（なければ wrapper）
      const searchW = panel?.querySelector('form') || panel?.querySelector('.develic-search-wrapper');

      // 一覧は「最後の .develic-items-wrapper」を採用
      const listW   = getLatestListWrap(section);

      const filters = section.querySelector('.wo-map-filters');

      if(!panel || !body) return;

      // 見えるよう保険
      panel.hidden = false;
      panel.style.display = 'block';
      panel.style.visibility = 'visible';

      // placeholder統一
      section.querySelectorAll('input.develic-search-input[type="search"]').forEach(i=>{
        i.setAttribute('placeholder','地図・店舗名で検索');
      });

      // フィルターを検索の直後へ（枠外なら枠内へ）
      if(filters){
        if(!filters.closest('.develic-left-panel')){
          panel.insertAdjacentElement('afterbegin', filters);
        }
        const anchor = searchW || panel.firstElementChild || panel;
        if(filters.previousElementSibling !== anchor){
          anchor.insertAdjacentElement('afterend', filters);
        }
      }

      // 並び：検索→フィルター→一覧（存在するものだけ）
      const desired = [searchW, filters, listW].filter(Boolean);
      desired.forEach(n => { if(n && n.parentElement !== panel) panel.appendChild(n); });

      // 一覧の複製対策：最新だけ表示
      ensureSingleList(section);

      section.classList.add('wo-mm-ready');
    }catch(e){
      console.error('[wo-map-mobile] apply error', e);
    }
  }

  function boot(){
    try{
      const section = document.querySelector('.wo-home-map');
      if(!section) return;          // ← ないページでは動かない
      apply(section);

      // セクション内だけ監視（Omniumの差し替えに追従）
      const mo = new MutationObserver(()=>apply(section));
      mo.observe(section, {childList:true, subtree:true});

      MQ.addEventListener?.('change', ()=>apply(section));
    }catch(e){
      console.error('[wo-map-mobile] boot error', e);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
})();
